import { FaCheckCircle, FaTimesCircle, FaTimes } from 'react-icons/fa';

interface StatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'success' | 'error';
  title: string;
  message: string;
}

const StatusModal: React.FC<StatusModalProps> = ({ isOpen, onClose, type, title, message }) => {
  if (!isOpen) return null;

  const isSuccess = type === 'success';

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 animate-in fade-in duration-300">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-[32px] p-8 md:p-12 max-w-sm w-full shadow-2xl text-center scale-in-center animate-in zoom-in-95 duration-300">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-6 right-6 p-2 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <FaTimes size={20} />
        </button>

        <div className={`w-20 h-20 ${isSuccess ? 'bg-[var(--success-bg)]' : 'bg-red-50'} rounded-full flex items-center justify-center mx-auto mb-6`}>
          {isSuccess ? (
            <FaCheckCircle className="text-[var(--success-text)] text-4xl" />
          ) : (
            <FaTimesCircle className="text-red-500 text-4xl" />
          )}
        </div>
        <h3 className="text-2xl font-serif font-black text-[var(--text-primary)] mb-3">{title}</h3>
        <p className="text-[var(--text-gray)] font-medium mb-8 leading-relaxed">
          {message}
        </p>
        <button
          onClick={onClose}
          className={`w-full py-4 ${isSuccess ? 'bg-[var(--primary)]' : 'bg-red-500'} text-white font-black uppercase tracking-widest text-xs rounded-xl shadow-lg transition-all active:scale-95`}
        >
          {isSuccess ? 'Great, thanks!' : 'Try Again'}
        </button>
      </div>
    </div>
  );
};

export default StatusModal;
